import { render } from "./Npa.vue?vue&type=template&id=95d8f518&scoped=true"
import script from "./Npa.vue?vue&type=script&lang=js"
export * from "./Npa.vue?vue&type=script&lang=js"

import "./Npa.vue?vue&type=style&index=0&id=95d8f518&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95d8f518"]])

export default __exports__